import { render } from "./MossHeader.vue?vue&type=template&id=428a8138"
import script from "./MossHeader.vue?vue&type=script&lang=js"
export * from "./MossHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__